import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'

const getSelectedStyle = ({
  $isActive,
  $isHeader
}: {
  $isActive: boolean
  $isHeader: boolean
}) => {
  if ($isHeader) {
    if ($isHeader) {
      return css`
        padding: 6px 2px;
      `
    }
  }
  if ($isActive) {
    return css`
      background: ${COLORS.primaryLight};
      border: 1px solid ${COLORS.primaryDark};
    `
  }
  return css`
    @media only screen and (min-width: ${MOBILE_SIZE_BREAKPOINT}px) {
      &:hover {
        background: ${COLORS.primaryLight};
        p {
          color: ${COLORS.secondaryDark};
        }
      }
    }
  `
}

export const TtsSpeakerItemWrapper = styled.div<{
  $isActive: boolean
  $isHeader: boolean
}>`
  position: relative;
  min-height: 44px;
  width: 100%;
  padding: 6px 14px 6px 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  border-radius: 4px;
  ${getSelectedStyle}

  cursor: pointer;
  transition: all 0.3s;
`
